export const DEFAULT_ERROR_MESSAGE = "Oops something went wrong.";
// export const TILE_PRODUCTS = ["Ceramic", "Porcelain", "Trim & Accents", "Trims_And_Accents", "Natural Stone", "Natural_Stone", "Decorative Accessories", "Decorative_Accessories", "Mosaics"];
export const TILE_PRODUCTS = [
  "CERAMIC",
  "PORCELAIN",
  "TRIM_ACCENTS",
  "NATURAL_STONE",
  "DECORATIVE_ACCESSORIES",
  "Mosaics",
];
export enum ResidentialPlpTypes {
  carpetproduct = "carpetproduct",
  carpetproduct_airo = "airo",
  carpetproduct_smartstrand = "smartstrand",
  carpetproduct_everstrand = "everstrand",
  carpetproduct_ultrastrand = "ultrastrand",
  carpetproduct_commercial_broadloom = "commercial_broadloom",
  carpetproduct_residential_broadloom = "residential_broadloom",
  carpetproduct_carpet_tile = "carpet_tile",
  carpetproduct_woven = "woven",
  carpetproduct_wool = "wool",
  carpet_wall_base_and_stair_solutions = "carpet_wall_base_and_stair_solutions",
  carpet_care_and_maintenance = "carpet_care_and_maintenance",
  cushionproduct = "cushionproduct",
  cushionproduct_rebond = "cushionproduct_rebond",
  cushionproduct_memory_foam = "cushionproduct_memory_foam",
  cushionproduct_synthetic = "cushionproduct_synthetic",
  cushionproduct_rug_assist = "cushionproduct_rug_assist",
  wood = "wood",
  wood_tecwood = "wood_tecwood",
  wood_belleluxe = "wood_belleluxe",
  wood_revwood = "wood_revwood",
  wood_pergo_elements = "wood_pergo_elements",
  wood_ultrawood = "wood_ultrawood",
  wood_underlayment = "wood_underlayment",
  wood_trim_and_moldings = "smartstrand",
  wood_adhesives = "wood_adhesives",
  wood_wall_base_and_stair_solutions = "wood_wall_base_and_stair_solutions",
  wood_care_and_maintenance = "wood_care_and_maintenance",
  resilient_vinyl = "resilient_vinyl",
  resilient_vinyl_solidtech = "resilient_vinyl_solidtech",
  resilient_vinyl_pergo_extreme = "resilient_vinyl_pergo_extreme",
  resilient_vinyl_luxecraft = "resilient_vinyl_luxecraft",
  resilient_vinyl_versatech = "resilient_vinyl_versatech",
  resilient_vinyl_aladdin_commercial = "resilient_vinyl_aladdin_commercial",
  resilient_vinyl_underlaymen = "resilient_vinyl_underlaymen",
  resilient_vinyl_trim_and_moldings = "resilient_vinyl_trim_and_moldings",
  resilient_vinyl_adhesives = "resilient_vinyl_adhesives",
  resilient_vinyl_care_and_maintenance = "resilient_vinyl_care_and_maintenance",
  resilient_vinyl_wall_base_and_stair_solutions = "resilient_vinyl_wall_base_and_stair_solutions",
  tile = "tile",
  tile_ceramic = "tile_ceramic",
  tile_porcelain = "tile_porcelain",
  tile_natural_stone = "tile_natural_stone",
  tile_decorative_accessories = "tile_decorative_accessories",
  tile_trim_and_accents = "tile_trim_accents",
  merchandising = "merchandising",
  merchandising_display = "merchandising_display",
  merchandising_display_update = "merchandising_display_update",
  merchandising_graphics_and_stickers = "merchandising_graphics_and_stickers",
  merchandising_sales_tools = "merchandising_sales_tools",
  accessories = "accessories",
  accessories_wall_base_and_stair_solutions = "accessories_wall_base_and_stair_solutions",
  accessories_care_and_maintenance = "accessories_care_and_maintenance",
  accessories_underlayment = "accessories_underlayment",
  accessories_trim_and_moldings = "accessories_trim_and_moldings",
  accessories_adhesives = "accessories_adhesives",
  accessories_trim_and_accents = "accessories_trim_accents",
  accessories_installation_kits_and_tools = "accessories_installation_kits_and_tools",
  atpCheckProductTypes = '["COMMERCIAL_BROADLOOM","RESIDENTIAL_BROADLOOM","WOVEN","PRODUCT_SHEET","EVERSTRAND","RESILIENT_VINYL","NEEDLEPUNCH_BROADLOOM","WOOD_LAMINATE","UNDERLAYMENT","PAD_CUSHION","CARPET_TILE","CERAMIC","PORCELAIN","TRIM_ACCENTS"]',
  // atpCheckProductTypes = '["TUFTED_BROADLOOM","WOVEN_BROADLOOM","PDI_BROADLOOM","DEFINITY_BROADLOOM","BROADLOOM","RESILIENT_SHEET"]',
  account_sample_order_restriction = '["DISPLAY","DISPLAY_UPDATE","GRAPHICS_AND_STICKERS"]',
}

export const PdpPfxPriceFields: any = {
  RESIDENTIAL_BROADLOOM: [
    { fieldName: "Roll Price (USD)", key: "rollPriceSY", type: "sq. yd." },
    { fieldName: "Cut Price (USD)", key: "cutPriceSY", type: "sq. yd." },
    //{ fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  RESILIENT_VINYL: [
    { fieldName: "Roll Price (USD)", key: "rollPriceSY", type: "sq. yd." },
    { fieldName: "Cut Price (USD)", key: "cutPriceSY", type: "sq. yd." },
    { fieldName: "Carton Price (USD)", key: "cartonPriceSF", type: "sq. ft." },
    // { fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  NEEDLEPUNCH_BROADLOOM: [
    { fieldName: "Roll Price (USD)", key: "rollPriceSY", type: "sq. yd." },
    { fieldName: "Cut Price (USD)", key: "cutPriceSY", type: "sq. yd." },
    // { fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  COMMERCIAL_BROADLOOM: [
    { fieldName: "Roll Price (USD)", key: "rollPriceSY", type: "sq. yd." },
    { fieldName: "Cut Price (USD)", key: "cutPriceSY", type: "sq. yd." },
    // { fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  CARPET_TILE: [
    { fieldName: "Price (USD)", key: "cartonPriceSY", type: "sq. yd." },
      { fieldName: "Pallet Price (USD)", key: "palletPriceSY", type: "sq. yd." },
    // { fieldName: "Multi Pallet Price (USD)", key: "multiPalletPriceSY" },
  ],
  NEEDLEPUNCH_TILE: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSY", type: "sq. yd." },
     { fieldName: "Pallet Price (USD)", key: "palletPriceSY", type: "sq. yd." },
    // { fieldName: "Multi Pallet Price (USD)", key: "multiPalletPriceSY" },
  ],
  PAD_CUSHION: [
    // { fieldName: "Price Each (USD)", key: "priceEach" },
    // {
    //   fieldName: "Job Pack Price (USD)",
    //   key: "jobPackPriceSY",
    //   type: "sq. yd.",
    // },
    {
      fieldName: "Warehouse Price (USD)",
      key: "warehousePriceSY",
      type: "sq. yd.",
    },
    {
      fieldName: "Plant Direct Price (USD)",
      key: "plantDirectPriceSY",
      type: "sq. yd.",
    },
  ],
  SETTING_MATERIAL: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSY", type: "sq. yd." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSY", type: "sq. yd." },
  ],
  TRIM_ACCENTS: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSY", type: "sq. yd." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSY", type: "sq. yd." },
  ],
  CERAMIC: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSF", type: "sq. ft." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSF", type: "sq. ft." },
  ],
  MOSAICS: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSF", type: "sq. ft." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSF", type: "sq. ft." },
  ],
  PORCELAIN: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSF", type: "sq. ft." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSF", type: "sq. ft." },
  ],
  NATURAL_STONE: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSY", type: "sq. yd." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSY", type: "sq. yd." },
  ],
  DECORATIVE_ACCESSORIES: [
    { fieldName: "Price (USD)", key: "priceEach", type: "each." },
  ],
  DISPLAY: [{ fieldName: "Price (USD)", key: "listPrice", type: "each." }],
  DISPLAY_UPDATE: [
    { fieldName: "Price (USD)", key: "listPrice", type: "each." },
  ],
  SALES_TOOLS: [{ fieldName: "Price (USD)", key: "listPrice", type: "each." }],
  GRAPHICS_AND_STICKERS: [
    { fieldName: "Price (USD)", key: "listPrice", type: "each." },
  ],
  TRIM_AND_MOLDINGS: [
    { fieldName: "Price Each (USD)", key: "priceEach", type: "each." },
  ],
  WALL_BASE_AND_STAIR_SOLUTIONS: [
    { fieldName: "Price Each (USD)", key: "priceEach", type: "each." },
  ],
  UNDERLAYMENT: [{ fieldName: "Price (USD)", key: "priceEach", type: "each." }],
  ADHESIVES: [{ fieldName: "Price (USD)", key: "priceEach", type: "each." }],
  INSTALLATION_KITS_AND_TOOLS: [
    { fieldName: "Price Each (USD)", key: "priceEach", type: "each." },
  ],

  SAMPLES: [
    { fieldName: "Price Each (USD)", key: "priceEach", type: "each." },
    // { fieldName: "Cut Price (USD)", key: "cutPriceSY" },
    // { fieldName: "Roll Price (USD)", key: "rollPriceSY" },
    // { fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  BROADLOOM: [
    { fieldName: "Roll Price (USD)", key: "rollPriceSY", type: "sq. yd." },
    { fieldName: "Cut Price (USD)", key: "cutPriceSY", type: "sq. yd." },

    // { fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  RUBBER: [
    { fieldName: "Roll Price (USD)", key: "rollPriceSY", type: "sq. yd." },
    { fieldName: "Cut Price (USD)", key: "cutPriceSY", type: "sq. yd." },

    // { fieldName: "Multi Roll Price (USD)", key: "multiRollPriceSY" },
  ],
  WOOD_LAMINATE: [
    { fieldName: "Carton Price (USD)", key: "cartonPriceSF", type: "sq. ft." },
    { fieldName: "Pallet Price (USD)", key: "palletPriceSF", type: "sq. ft." },
  ],
  CARE_MAINTENANCE: [
    { fieldName: "Price Each (USD)", key: "priceEach", type: "each" },
  ],
};


export const REPLACEMENT_REASONS_MAP = {
  ZE4: "Customer Choice / Accommodation Return",
  ZE3: "Damaged",
  ZE5: "Quality Concern",
  ZE1: "Wrong Product",
  ZE2: "Wrong Quantity",
};

export const ORDER_FLOW_TYPE = {
  DEFAULT: 'Default',
  VIEW_INVENTORY: 'View Inventory',
}